/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {PopoverDirective} from 'ngx-bootstrap/popover';
import template from './order-list-filters.component.html';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED],
  selector: 'adn-order-list-filters',
  template
})
export class OrderListFiltersComponent implements OnChanges {
  @Input() list: any;

  @ViewChild('joinFilterPopoverTrigger', {read: PopoverDirective}) joinFilterPopoverDir: PopoverDirective;

  readonly executionStateOptions = ['NOT_READY', 'READY', 'RUNNING', 'ENDED'];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.list && this.list && !this.list.joinFilterBy) {
      this.list.joinFilterBy = this.list.limitedFilter ? 'Salesperson' : 'Advertiser';
    }
  }

  applyJoinFilter(): void {
    this.list?.filterOnSelect?.('order');
    this.joinFilterPopoverDir?.hide();
  }

  clearJoinFilter(): void {
    this.list?.filterOnSelect?.('order', true);
  }
}
